export default "__VITE_ASSET__B3Sq3ILM__"